import React from "react";
import RouterConfigs from "./router/router.config";
import {BrowserRouter} from "react-router-dom";
import {CoreUIProvider} from "@dladio/core-ui";
import AppBridgeProvider from "@dladio/app-bridge/dist/components/AppBridgeProvider";


function App() {
    return (
        <AppBridgeProvider apiKey={"report-builder-app"}>
            <CoreUIProvider>
                <BrowserRouter>
                    <>
                        <RouterConfigs/>
                    </>
                </BrowserRouter>
            </CoreUIProvider>
        </AppBridgeProvider>
    );
}

export default App;
